<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card>
        <v-card-title class="pb-0">
          <h1 class="headline font-weight-medium mb-2 mx-1">
            {{ isNew ? "Створення Джерела Коштів" : "Джерело Коштів" }}
          </h1>
          <v-spacer />
          <ActionsModalWindow
            v-if="modal"
            :id="id"
            component-name="PaymentSource"
            @close="$emit('close')"
          />
        </v-card-title>
        <v-form>
          <v-card-text class="py-0">
            <v-row>
              <v-col cols="12" class="pb-0">
                <CustomTextField
                  v-model="title"
                  label="Найменування*"
                  class="ma-1"
                  :error-messages="$v.title.$error ? errors.TITLE : []"
                  :hide-details="false"
                  @input="$v.title.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col md="6" sm="12" class="mt-n4">
                <CustomTextField
                  v-model="accountNumber"
                  label="Номер Рахунка"
                  class="ma-1"
                  @input="isChanged = true"
                />
              </v-col>
              <v-col md="6" sm="12" class="mt-n4">
                <EnumSelect
                  v-model="rolePaymentType"
                  class="mt-1"
                  :items="paymentTypes"
                  label="Тип Оплати"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <PrimaryBtn
              :has-warnings="$v.$invalid"
              :loading="loading"
              @click="save"
            />
            <v-btn v-if="!modal" @click="$router.go(-1)">
              Відмінити
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import EnumSelect from "@/components/selects/EnumSelect.vue";
import * as sourcesApi from "../../../backend/sourcesApi.js";
import paymentTypes from "../../../helpers/paymentTypes.js";
import PrimaryBtn from "@/components/PrimaryBtn.vue";
import { ERRORS } from "@/helpers";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    EnumSelect,
    PrimaryBtn,
    ActionsModalWindow() {
      return import("@/components/ActionsModalWindow.vue");
    },
  },
  props: ["id", "modal"],

  data: () => ({
    title: "",
    accountNumber: "",
    rolePaymentType: null,
    loading: false,
    isChanged: false,
  }),

  validations: {
    title: {
      required,
    },
  },

  computed: {
    isNew() {
      return +this.id ? false : true;
    },
    paymentTypes() {
      return [
        {
          value: paymentTypes.BANK.value,
          text: paymentTypes.BANK.title,
        },
        {
          value: paymentTypes.CARD.value,
          text: paymentTypes.CARD.title,
        },
        {
          value: paymentTypes.CASH.value,
          text: paymentTypes.CASH.title,
        },
      ];
    },
    errors() {
      return {
        TITLE: [ERRORS.REQUIRED],
      };
    },
  },
  created() {
    if (+this.id) {
      sourcesApi.getPaymentSource(this.id).then((source) => {
        this.title = source.title;
        this.accountNumber = source.accountNumber;
        this.rolePaymentType = this.paymentTypeVariants.find(
          (pt) => pt.value === source.paymentType
        ).value;
      });
    }
  },
  methods: {
    async save() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;

      const paymentSource = {
        title: this.title,
        accountNumber: this.accountNumber,
        paymentType: this.rolePaymentType ? this.rolePaymentType : 0,
      };

      try {
        if (!this.isNew) {
          await sourcesApi.updatePaymentSource(this.id, paymentSource);
        } else {
          await sourcesApi.createPaymentSource(paymentSource);
        }
        this.$notifySuccess();
        this.modal ? this.$emit("close") : this.$router.go(-1);
      } catch {
        this.$notifyWarning();
      } finally {
        this.loading = false;
        this.isChanged = false;
      }
    },
  },
};
</script>
